import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  TextField,
  Typography,
  RadioGroup,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import axios from "axios";
import Referraldetails from "./Referraldetails";
import { useAuth } from "../Context/AuthContext";
import CloseIcon from "@mui/icons-material/Close";
import Thankreferral from "./Thankreferral";
const apiUrl = process.env.REACT_APP_API_REST_URL;

const Addreferral = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const { token } = useAuth();
  const [enteredFirstName, setEnteredFirstName] = useState("");
  const [enteredLastName, setEnteredLastName] = useState("");
  console.log("tokenwa", token);

  const [userId, setUserId] = useState(null);
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onTouched" });
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    console.log("data", data);
    const token = sessionStorage.getItem("authToken");
    const headers = {
      "x-access-token": token,
    };
    try {
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/referalEngine/preReferral`,
        {
          ...data,
          status: "referral",
          source: "referral",
          created_by: sessionStorage.getItem("userId"),
        },
        { headers }
      );
      console.log("Response: refwa", response.data.response);
      console.log(data, "datda");
      if (response) {
        if (response.data.userAlreadyExist) {
          toast.error("Email/Phone already exist!");
        } else {
          toast.success("Referral details added successfully!");
          const userId = response.data.response.id; // Access the 'id' property from the response
          const clientId = response.data.response.clientId;
          // console.log("hello", userId, clientId)
          navigate("/thank", {
            state: {
              clientId,
              firstname: data.firstname,
              lastname: data.lastname,
            },
          });
          <Referraldetails userId={userId} />;
          setEnteredFirstName(data.firstname);
          setEnteredLastName(data.lastname);
        }
      }
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Error in adding Referral details.");
    }

    <Thankreferral firstname={data.firstname} lastname={data.lastname} />;
    // console.log("data22", data.firstname);
  };
  // const [thankReferralContent, setThankReferralContent] = useState(null);

  const handleCancel = () => {
    navigate("/dashboard");
  };

  return (
    <>
      {isSmallScreen ? (
        <span>
          <Box sx={styles.formboxresponsive}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>

            {userId && <Referraldetails userId={userId} />}
            <h3>Add Referral Details</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <div>
                  <TextField
                    sx={styles.textfieldtopres}
                    id="outlined-basic"
                    label="First name"
                    variant="outlined"
                    {...register("firstname", {
                      required: "First Name is required",
                      pattern: {
                        value: /^[A-Za-z]+$/,
                        message: "First Name should only contain letters",
                      },
                    })}
                  />
                  {errors.firstname && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        margin: "0px 0px 0px 20px",
                      }}
                    >
                      {errors.firstname.message}
                    </div>
                  )}
                </div>
                <div>
                  <TextField
                    sx={styles.textfieldtopres}
                    id="outlined-basic"
                    label="Last name"
                    variant="outlined"
                    {...register("lastname", {
                      required: "Last Name is required",
                      pattern: {
                        value: /^[A-Za-z]+$/,
                        message: "Last Name should only contain letters",
                      },
                    })}
                  />
                  {errors.lastname && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        margin: "0px 0px 0px 20px",
                      }}
                    >
                      {errors.lastname.message}
                    </div>
                  )}
                </div>
              </Box>
              <Box sx={{ marginTop: "10px", alignItems: "center" }}>
                <div style={{ marginTop: "12px" }}>
                  {/* <label>Email address:</label> */}
                  <TextField
                    sx={styles.textfieldres}
                    id="outlined-basic"
                    label="Email address"
                    variant="outlined"
                    {...register("email", {
                      required: "Email address is required",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Invalid Email Address",
                      },
                    })}
                  />
                  {errors.email && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        margin: "0px 0px 0px 20px",
                      }}
                    >
                      {errors.email.message}
                    </div>
                  )}
                </div>
              </Box>
              <Box sx={{ marginTop: "10px", alignItems: "center" }}>
                <div style={{ margin: "12px 0px 14px 0px" }}>
                  {/* <label>Phone number:</label> */}
                  <TextField
                    sx={styles.textfieldres}
                    id="outlined-basic"
                    label="Phone number"
                    variant="outlined"
                    inputProps={{ maxLength: 10 }}
                    {...register("phone", {
                      required: "Phone number is required",
                      pattern: {
                        value: /^\d{10}$/,
                        message: "Invalid Phone Number (10 digits)",
                      },
                      validate: (value) =>
                        !!value || !!watch("email") || "Phone is required",
                      onChange: (e) =>
                        (e.target.value = e.target.value.replace(/\D/g, "")),
                    })}
                  />
                  {errors.phone && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        margin: " 2px 0px 0px 20px",
                      }}
                    >
                      {errors.phone.message}
                    </div>
                  )}
                </div>
              </Box>
              <Box
                sx={{ marginTop: "10px", textAlign: "center", margin: "15px" }}
              >
                <Typography
                  sx={{
                    margin: "10px 10px 0px 0px",
                    // display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Mention my name?
                  <RadioGroup
                    row
                    aria-label="consent"
                    name="consent"
                    defaultValue="yes" // Set a default value if needed
                  >
                    <FormControlLabel
                      sx={{ marginLeft: "60px" }}
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                      {...register("consent", {
                        required: "Please choose an option",
                      })}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                      {...register("consent", {
                        required: "Please choose an option",
                      })}
                    />
                  </RadioGroup>
                </Typography>
                {errors.consent && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      margin: "2px 0px 0px 0px",
                    }}
                  >
                    {errors.consent.message}
                  </div>
                )}
              </Box>
              <Box sx={{ display: "flex", margin: "10px" }}>
                <Button
                  onClick={handleCancel}
                  variant="outlined"
                  sx={styles.btncancel}
                >
                  Cancel
                </Button>

                <Button type="submit" sx={styles.btn}>
                  Submit
                </Button>
              </Box>
            </form>
            {/* Render ThankReferral component with entered firstname and lastname */}
            {enteredFirstName && enteredLastName && (
              <Thankreferral
                firstname={enteredFirstName}
                lastname={enteredLastName}
              />
            )}
          </Box>
        </span>
      ) : (
        <span>
          <Box sx={styles.formbox}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>

            {userId && <Referraldetails userId={userId} />}
            <h3>Add Referral Details</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <div>
                  <TextField
                    sx={styles.textfieldtop}
                    id="outlined-basic"
                    label="First name"
                    variant="outlined"
                    {...register("firstname", {
                      required: "First Name is required",
                      pattern: {
                        value: /^[A-Za-z]+$/,
                        message: "First Name should only contain letters",
                      },
                    })}
                  />
                  {errors.firstname && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        margin: " 2px 0px 0px 20px",
                      }}
                    >
                      {errors.firstname.message}
                    </div>
                  )}
                </div>
                <div>
                  <TextField
                    sx={styles.textfieldtop}
                    id="outlined-basic"
                    label="Last name"
                    variant="outlined"
                    {...register("lastname", {
                      required: "Last Name is required",
                      pattern: {
                        value: /^[A-Za-z]+$/,
                        message: "Last Name should only contain letters",
                      },
                    })}
                  />
                  {errors.lastname && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        margin: " 2px 0px 0px 20px",
                      }}
                    >
                      {errors.lastname.message}
                    </div>
                  )}
                </div>
              </Box>
              <Box sx={{ marginTop: "10px", alignItems: "center" }}>
                <div style={{ marginTop: "12px" }}>
                  {/* <label>Email address:</label> */}
                  <TextField
                    sx={styles.textfield}
                    id="outlined-basic"
                    label="Email address"
                    variant="outlined"
                    {...register("email", {
                      required: "Email address is required",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Invalid Email Address",
                      },
                    })}
                  />
                  {errors.email && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        margin: " 2px 0px 0px 20px",
                      }}
                    >
                      {errors.email.message}
                    </div>
                  )}
                </div>
              </Box>
              <Box sx={{ marginTop: "10px", alignItems: "center" }}>
                <div style={{ margin: "12px 0px 14px 0px" }}>
                  {/* <label>Phone number:</label> */}
                  <TextField
                    sx={styles.textfield}
                    id="outlined-basic"
                    label="Phone number"
                    variant="outlined"
                    inputProps={{ maxLength: 10 }}
                    {...register("phone", {
                      required: "Phone number is required",
                      pattern: {
                        value: /^\d{10}$/,
                        message: "Invalid Phone Number (10 digits)",
                      },
                      validate: (value) =>
                        !!value || !!watch("email") || "Phone is required",
                      onChange: (e) =>
                        (e.target.value = e.target.value.replace(/\D/g, "")),
                    })}
                  />
                  {errors.phone && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        margin: " 2px 0px 0px 20px",
                      }}
                    >
                      {errors.phone.message}
                    </div>
                  )}
                </div>
              </Box>
              <Box
                sx={{ marginTop: "10px", textAlign: "center", margin: "15px" }}
              >
                <Typography
                  sx={{
                    margin: "10px 10px 0px 0px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Mention my name?
                  <RadioGroup
                    row
                    aria-label="consent"
                    name="consent"
                    defaultValue="yes" // Set a default value if needed
                  >
                    <FormControlLabel
                      sx={{ marginLeft: "10px" }}
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                      {...register("consent", {
                        required: "Please choose an option",
                      })}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                      {...register("consent", {
                        required: "Please choose an option",
                      })}
                    />
                  </RadioGroup>
                </Typography>
                {errors.consent && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      margin: "2px 0px 0px 0px",
                    }}
                  >
                    {errors.consent.message}
                  </div>
                )}
              </Box>
              <Box sx={{ display: "flex", margin: "10px" }}>
                <Button
                  onClick={handleCancel}
                  variant="outlined"
                  sx={styles.btncancel}
                >
                  Cancel
                </Button>

                <Button type="submit" sx={styles.btn}>
                  Submit
                </Button>
              </Box>
            </form>
            {/* Render ThankReferral component with entered firstname and lastname */}
            {enteredFirstName && enteredLastName && (
              <Thankreferral
                firstname={enteredFirstName}
                lastname={enteredLastName}
              />
            )}
          </Box>
        </span>
      )}
    </>
  );
};

export default Addreferral;

const styles = {
  formbox: {
    position: "absolute",
    top: "51.5%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    // height:"450px",
    width: "420px",
  },
  formboxresponsive: {
    position: "absolute",
    top: "51.5%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    // height:"450px",
    width: "320px",
  },
  formboxtwo: {
    position: "absolute",
    top: "82%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "30px",
    width: "520px",
  },
  btn: {
    margin: "1em 1em 1em 1em",
    width: "220px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  btncancel: {
    margin: "1em 1em 1em 1em",
    width: "220px",
    backgroundColor: "white",
    color: "black",
    textTransform: "none",
    "&:hover": {
      background: "white",
    },
  },
  textfield: {
    width: "390px",
  },
  textfieldres: {
    width: "300px",
  },
  textfieldtop: {
    width: "185px",
    marginLeft: "16px",
  },
  textfieldtopres: {
    width: "135px",
    marginLeft: "16px",
  },
};
